/**
 * MCP 附件上传落地页（`/upload/:token`，src/features/attachments/publicUpload.ts）
 * 三个公开端点的 URL 判定 —— 从 axios-config.ts 的拦截器里抽出来,纯函数、零依赖,
 * 方便单测(拦截器本体挂在真实 axios 实例上,不适合直接单测)。
 *
 * 三个端点、且只这三个:
 *   - GET  /pms/attachments/upload-sessions/{token}          （拉 session，token 失效/过期）
 *   - POST /pms/attachments/upload-sessions/{token}/presign   （上传中途 session 过期）
 *   - POST /pms/attachments/upload-sessions/{token}/commit    （提交时 session 过期）
 *
 * 两个调用点，各自的"匹配即怎样"含义不同（2026-08-28 review 后从单一用途扩成双用途）：
 *   1. 响应拦截器（axios-config.ts ~190）—— 404 静默：这三个端点的 404 是匿名访客
 *      的正常业务态（token 失效/过期，落地页自己渲染失效卡片），全局 toast 只是噪音。
 *   2. 请求拦截器（axios-config.ts ~58）—— 认证跳过：token 即授权，这三个端点匿名
 *      访问，不该也不需要贴 Clerk/localStorage 的 Authorization 头；见 Web Task 6
 *      report 记录的真实挂起 bug（ClerkAuthProvider 把 getToken 挂到
 *      window.__getClerkToken 早于本页面 mount，本机 pk_live_ key 在 localhost
 *      域名下 Clerk 400、getToken() 永久不 resolve，导致公开页面卡死在 Loading）。
 *
 * "fails closed" 契约：两个调用点都是"匹配到才特殊处理，匹配不到就走原有的默认行为"
 * （默认行为 = 404 弹 toast / 请求照常尝试贴认证头）。也就是说，一旦正则误判
 * 某个真实需要认证的端点为"公开上传端点"，后果是该请求被静默跳过认证头——
 * 这是本文件收紧到三个具体形状而非宽松匹配 `/upload-sessions/` 的原因：宁可
 * 少匹配（漏掉未来新增的公开端点，行为只是退化成原样，仍然安全）也不能多匹配
 * （误伤 `GET /pms/attachments/{id}` 这类需要认证的真实附件详情路径）。
 */
export function isUploadSessionRequestUrl(url: string | undefined): boolean {
  return /\/pms\/attachments\/upload-sessions\/[^/]+(?:\/(?:presign|commit))?$/.test(url ?? '')
}
